import axios from 'axios';
import * as utils from "@sentry/utils";

axios.defaults.baseURL = process.env.VUE_APP_PW_URL;
axios.defaults.withCredentials = true;
axios.defaults.timeout = 60000;

// sentry tracing
if (typeof window.env !== 'undefined' && window.env.sentryDsn !== "null" && typeof window.pageLoadTransaction !== 'undefined') {
    // Create `sentry-trace` header
    const sentryTraceHeader = window.pageLoadTransaction!.toTraceparent();

    // Create `baggage` header
    const dynamicSamplingContext = window.pageLoadTransaction!.getDynamicSamplingContext();
    axios.defaults.headers.common['baggage'] = utils.dynamicSamplingContextToSentryBaggageHeader(
        dynamicSamplingContext
    );
    axios.defaults.headers.common['sentry-trace'] = sentryTraceHeader;
}

export default axios;
